import dayjs from 'dayjs';
import { isValidPhoneNumber } from 'react-phone-number-input';

import { MaxLengths } from './constants';

export default class Validation {
  public static email = {
    regex:
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    maxLength: MaxLengths.Email,
    isValid(value: string): boolean {
      return this.regex.test(value);
    },
  };

  public static firstName = {
    regex: /^[^±!@£$%^&*_+§¡€#¢§¶•ªº«\\/<>\\{\\}?:;|=.,1-9]+$/,
    maxLength: MaxLengths.FirstName,
    isValid(value: string): boolean {
      return this.regex.test(value);
    },
  };

  public static lastName = {
    regex: /^[^±!@£$%^&*_+§¡€#¢§¶•ªº«\\/<>\\{\\}?:;|=.,1-9]+$/,
    maxLength: MaxLengths.LastName,
    isValid(value: string): boolean {
      return this.regex.test(value);
    },
  };

  public static zip = {
    regex: {
      CA: /^[a-zA-Z0-9\s?]{6,7}$/,
      US: /^[0-9]{5,5}$/,
    },
    maxLength: {
      CA: 6,
      US: 5,
    },
    isValid: (country: string, value?: string): boolean => {
      if (['CA', 'US'].includes(country)) {
        return this.zip.regex[country as 'CA' | 'US'].test(value || '');
      }
      return true;
    },
  };

  public static mlifeNumber = {
    regex: /[0-9]+$/,
    isValid(value: string): boolean {
      return this.regex.test(value);
    },
  };

  public static address = {
    maxLength: MaxLengths.Address,
  };

  public static activationCode = {
    regex: /^\d{6}$/,
    maxLength: 6,
    isValid(value: string): boolean {
      return this.regex.test(value);
    },
  };

  public static password = {
    minLength: 12,
    maxLength: MaxLengths.Password,
    validate: (password: string) => {
      const validations = {
        length: password.length >= this.password.minLength,
        uppercase: !!password.match(/(?=.*[A-Z])/),
        lowercase: !!password.match(/(?=.*[a-z])/),
        number: !!password.match(/(?=.*[0-9])/),
        // eslint-disable-next-line no-useless-escape
        specialCharacter: !!password.match(/(?=.*["!#$%&'()*+,-./\\:;<=>?@^_`{|}~\[\]])/),
      };

      return [Object.values(validations).every(validation => validation), validations] as const;
    },
    isValid: (password: string) => {
      const [isValid] = this.password.validate(password);
      return isValid;
    },
  };

  public static age = {
    min: 21,
    isValid: (value: string) => {
      try {
        const age = dayjs().diff(new Date(value), 'years');
        return age >= this.age.min && !isNaN(age);
      } catch (e) {
        // Birthday is not a valid date
        return false;
      }
    },
  };

  public static phoneNumber = {
    isValid: (value: string | undefined) => {
      if (value) return isValidPhoneNumber(value);
      else return false;
    },
  };
}
